<template>
    <vx-card id="loader">
        <vs-row vs-w="12">
            <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                <div class="vx-row header-title mb-4">
                    <h1>Ключевые слова для автотегов</h1>
                </div>
            </vs-col>
        </vs-row>

        <div class="vx-row header-title ml-1 mt-3 mb-2">
            <h4>Фильтры</h4>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.keyword" autocomplete="off" v-on:keyup.enter="loadKeywordAdTags()"
                        label="По названию" class="mt-1 w-full" />
                </div>
            </div>
            <div class="pt-2">
                <vx-tooltip text="Очистить список" position="top" delay=".3s">
                    <feather-icon icon="XIcon" @click="form.keyword = ''"
                        class="inline-block text-danger cursor-pointer" svgClasses="w-5 h-5" />
                </vx-tooltip>
            </div>
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="required">Теги</label>
                    <v-select :options="dicts.adTags" placeholder="Выберите теги" class="w-full" label="name" multiple
                        v-model="form.adTags" :reduce="(a) => a.id">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mt-1">
            <div class="vx-col w-5/6 mb-1">
                <div class="mt-1">
                    <vs-button class="mt-2" color="success" @click="loadKeywordAdTags()" type="filled"> Применить
                    </vs-button>
                    <vs-button class="ml-5" color="rgb(250, 130, 80)" @click="createKeywordAdTags()" type="filled">
                        Добавить ключевое слово
                    </vs-button>
                </div>
            </div>

            <div class="vx-col w-1/6 mb-1">
                <div class="mt-1 pt-3">
                    <v-select :options="dicts.pageSizes" label="keyword" placeholder="На странице..."
                        class="ml-1 page-size inline-block" v-model="pageSize" :clearable="false"
                        @input="loadKeywordAdTags()">
                    </v-select>
                </div>
            </div>
        </div>

        <vs-table style="min-height: 500px;" v-model="selected" :data="keywordAdTags" max-items="10" class="mt-5"
            :sst="true" stripe>
            <template slot="thead">
                <vs-th> Id </vs-th>
                <vs-th> Ключевое слово</vs-th>
                <vs-th class="vs-lg-5"> Теги </vs-th>
                <vs-th class="vs-lg-1"> Действия </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.id }}</vs-td>
                    <vs-td><vs-input v-model="tr.keyword" autocomplete="off" class="mt-1 w-full" /></vs-td>
                    <vs-td>
                        <v-select :options="dicts.adTags" placeholder="Выберите теги" class="w-full" label="name"
                            multiple v-model="tr.adTagIds" :reduce="(a) => a.id">
                        </v-select>
                    </vs-td>
                    <vs-td>
                        <div>
                            <div class="inline-block cursor-pointer">
                                <vx-tooltip :disabled="!tr.keyword" text="Сохранить" position="top" delay=".3s">
                                    <feather-icon @click="saveChanges(tr)" icon="SaveIcon"
                                        class="inline-block mr-2 text-success" svgClasses="w-7 h-7" />
                                </vx-tooltip>
                            </div>
                        </div>
                        <div class="inline-block cursor-pointer">
                            <vx-tooltip text="Удалить ключевое слово" position="top" delay=".3s">
                                <feather-icon @click="showDeleteModal(tr)" icon="XCircleIcon"
                                    class="inline-block mr-2 text-danger" svgClasses="w-7 h-7" />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>

        <sweet-modal ref="deleteModal" icon="error" title="Удаление тега">
            <div class="mb-5">Вы действительно хотите удалить ключевое слово '{{ selected.keyword }}'?</div>

            <vs-button class="" color="danger" @click="deleteKeyworsAdTags(selected)" type="filled"> Удалить тег
            </vs-button>
        </sweet-modal>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';

export default {
    keyword: 'keywordAdTags',
    data() {
        return {
            keywordAdTags: [],
            selected: {},
            form: {
                allSelected: false,
                keyword: '',
                adTags: undefined
            },
            errors: {
                keyword: '',
            },
            dicts: {
                adTags: [],
                pageSizes: [5, 25, 50, 100, 500]
            },

            page: 1,
            pageSize: 50,
            pagesTotal: 1
        };
    },
    components: {
        vSelect,
        SweetModal,
        SweetModalTab
    },
    methods: {
        loadDicts() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios.all([
                this.axios.get('keywordAdTags/dicts'),
            ])
                .then(axios.spread((dicts) => {
                    this.dicts.adTags = dicts.data.adTags;
                }))
                .catch((err) => {
                    this.$vs.notify({
                        title: "Ошибка!",
                        text: "Ошибка загрузки справочников.",
                        color: "danger",
                    });
                })
                .finally(() => {
                    // this.$vs.loading.close("#loader > .con-vs-loading");
                });
        },
        loadKeywordAdTags() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                searchPattern: this.form.keyword ? this.form.keyword : undefined,
                adTagIds: this.form.adTags,
                page: this.page,
                size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('keywordAdTags', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    }),
                    this.axios.get('keywordAdTags/count', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    })
                ])
                .then(
                    axios.spread((keywordAdTags, count) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.keywordAdTags = keywordAdTags.data;
                        this.pagesTotal = Math.ceil(count.data / this.pageSize);
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки ключевых слово.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        showDeleteModal(keywordAdTags) {
            this.selected = keywordAdTags;
            this.$refs.deleteModal.open();
        },
        deleteKeyworsAdTags(keywordAdTags) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            this.$axios({
                method: 'DELETE',
                url: 'keywordAdTags/' + keywordAdTags.id,
                errors: this.errors,
                success: () => {
                    this.keywordAdTags = this.keywordAdTags.filter((c) => c.id != keywordAdTags.id);
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно удалено',
                        text: 'Ключевое слово успешно удалено',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Ошибка при удалении!',
                        text: err.response.data,
                        color: 'danger'
                    });
                },
                finally: ()=>
                {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                }
            });
        },
        createKeywordAdTags() {
            this.$router.push('/content-quality/keyword-ad-tags/create');
        },
        saveChanges(tr) {
            if (!this.paramsIsValid(tr)) {
                return;
            }
            tr.keyword = tr.keyword.trim();
            const params = {
                id: tr.id,
                keyword: tr.keyword,
                adTagIds: tr.adTagIds
            };

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'PUT',
                url: 'keywordAdTags/' + tr.id,
                params: params,
                errors: this.errors,
                success: (response) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Ключевое слово успешно обновлено',
                        color: 'success'
                    });
                    this.loadSspTypes();
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    if (err.request.status == 422 && err.data.errors) {
                        const error = err.data.errors;
                        return this.$vs.notify({
                            title: 'Внимание!',
                            text: error,
                            color: 'danger'
                        });
                    }

                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при обновлении ключевого слова!',
                        color: 'danger'
                    });
                },                
                finally: ()=>
                {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                }
            });
        },
        paramsIsValid(tr) {
            if (!tr.keyword) {
                this.$vs.notify({
                    title: 'Внимание!',
                    text: 'Введите ключевое слово',
                    color: 'warning'
                });
                return false;
            }

            if (!tr.adTagIds) {
                this.$vs.notify({
                    title: 'Внимание!',
                    text: 'Выберите теги',
                    color: 'warning'
                });
                return false;
            }

            return true;
        },
    },
    watch: {
        page: function () {
            this.loadKeywordAdTags();
        }
    },
    mounted() {
        this.loadDicts();
        this.loadKeywordAdTags();
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Автотеги';
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}

.header-title {
    flex-direction: column;
}

.textarea {
    border: 1px solid lightgrey !important;
    background-color: RGB(245, 245, 245);
}

.vs-pagination-primary {
    margin-top: 10px;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    -webkit-transform: none !important;
}

.vs-con-tbody.vs-table--tbody {
    min-height: 500px;
}
</style>